import React, { useState } from "react";
import CollaborationHead from "../../component/CollaborationHead/CollaborationHead";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Collaboration = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <CollaborationHead />
      <section id="service-details" className="service-details">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 mobcol">
            <div className="col-lg-12">
              <h3>Collaboration</h3>

              <ul>
                <p>
                  Collaboration using the medium of Information Technology is a
                  key approach through which data protection activities can be
                  used to add positively to the attainment of the Sustainable
                  Development Goals (SDGs) of the United Nations by 2030. This
                  platform is provided to enable volunteer members to select
                  Data Protection areas of collaboration which will directly
                  impact on the achievement of some of the SDGs. Find below the
                  available areas of collaboration:
                </p>
                <li>
                  {/* <i className="bi bi-check-circle"></i>{" "} */}
                  <span className="bolder">
                    1. Data Protection Awareness Campaign
                  </span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  Despite the fact that the General Data Protection Regulation
                  (GDPR) of the European Union, tries to globalize the adoption
                  of Data Protection Regulation, it is a fact that some nations
                  of the world have not implemented any data protection
                  regulation. In fact about 1 billion out of the population of
                  the world do not have digital identity. We therefore want some
                  members of this group to volunteer and take up the challenges
                  of campaign efforts to their local level, national and
                  international level. This effort will involve training,
                  educating and spreading the knowledge to several people. A
                  multilevel approach to marketing campaign can be adopted which
                  when somebody is aware, he/she can also tell others about the
                  project. By so doing, jobs will be created, and if someone is
                  gainfully employed, it will remove poverty and hunger and
                  quality education can be achieved.
                </p>
                <li>
                  {/* <i className="bi bi-check-circle"></i>{" "} */}
                  <span className="bolder">
                    2. Capacity Building for Data Protection Regulation
                  </span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  Those who want to embark upon the campaign awareness need to
                  be properly trained. The second group of volunteer
                  collaborators are expected to be experts in data protection
                  field and are ready to train others on how to become experts.
                  If this is carefully done, a workforce of data protection
                  professional will be produced who would be involved in data
                  protection audit, Impact Assessment, and campaign efforts for
                  the subject.
                </p>
                <li>
                  {/* <i className="bi bi-check-circle"></i>{" "} */}
                  <span className="bolder">
                    3. Policy Implementation for Digital Transformation
                  </span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  Digital transformation is increasingly supporting all sectors
                  of the economy, changing societies and market landscapes while
                  improving access to and delivery of services across multiple
                  industries. This will require greater collaboration between
                  policy-makers, regulatory authorities, and other stakeholders
                  to effectively harness technological progress and successfully
                  address the challenges of digitalization. The innovation will
                  bring together collaboration among institutions, industry
                  stakeholders, and cross-sector regulators for regulatory
                  relevance, coherence, and impact at the domestic, regional,
                  and international levels in areas such as health, finance,
                  education, transportation, and energy. Of course, when this is
                  done, some of the goals of United Nations would have been
                  achieved.
                </p>

                <li>
                  {/* <i className="bi bi-check-circle"></i>{" "} */}
                  <span className="bolder">
                    4. Data Protection Impact Assessment (DPIA)
                  </span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  DPIA involves a systematic evaluation of the potential
                  consequences of data processing activities on individuals'
                  privacy. It helps organizations identify any high risks,
                  assess the necessity and proportionality of the processing,
                  and define mitigation strategies. Performing DPIAs is crucial
                  to ensure compliance with data protection laws, build data
                  subjects' trust, and mitigate reputational risks. <br />
                  <br />A collaborative approach is essential to enable a
                  collective understanding of risks, foster better
                  decision-making, and promote a culture of accountability
                  throughout the organization. This platform seeks volunteers
                  who will work in this area of collaboration and carry out
                  impact Assessment Audit.
                </p>
                <li>
                  {/* <i className="bi bi-check-circle"></i>{" "} */}
                  <span className="bolder">5. Data protection Audit</span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  As mentioned earlier that data protection is a big business,
                  data protection auditors can emerge through collaboration and
                  can engage organization for audit work and also train other in
                  doing the same. By so doing, some of the goals of the United
                  Nations would be achieved.
                </p>
                <li>
                  {/* <i className="bi bi-check-circle"></i>{" "} */}
                  <span className="bolder">
                    6. Alignment of SDGs with Ethical Data Monitoring Activities
                  </span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  The members of this collaborative group will gather data about
                  the status of the sustainable development goals and measure
                  progress, difficulties, and provide the data for the group as
                  to know where the project has reached and what are the
                  obstacles confronting the attainment of the goals.
                </p>
                <li>
                  {/* <i className="bi bi-check-circle"></i>{" "} */}
                  <span className="bolder">
                    7. Support for funding the project
                  </span>
                </li>
                <p style={{ paddingLeft: "19px" }}>
                  As we all know that money is important in all that we do, we
                  solicit support from donors, local, national and international
                  well wishers to come to the aid of the project and donate
                  generously to the achievement of the goal.
                  <div style={{ width: "20%" }}>
                    <Button
                      className="battun"
                      onClick={() => {
                        navigate("/login");
                      }}
                    >
                      Login
                    </Button>
                    <Button
                      className="battun"
                      onClick={() => {
                        setShow(true);
                      }}
                    >
                      Join Now
                    </Button>
                  </div>
                </p>
              </ul>

              {/* <p>
                You can{" "}
                <Link to={`${process.env.PUBLIC_URL}/contact`}>contact</Link> us
                for a demonstration of this software.
              </p> */}
            </div>
          </div>
        </div>
      </section>
      {/* Modal  */}
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Membership Enrollment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" />
              </Form.Group>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>First Name</Form.Label>
                    <Form.Control type="text" />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control type="text" />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Organization</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  What is the status of your collaboration?
                </Form.Label>
                <Form.Select aria-label="Default select example">
                  <option>Select Item</option>
                  <option value="individual">
                    Set Up: I have an idea, but looking for others to join
                  </option>

                  <option value="organization">
                    Ideation: The group is brainstorming together
                  </option>
                  <option value="organization">
                    Scoping: Problems, solutions and resources required are
                    being defined
                  </option>
                  <option value="organization">
                    Implementation: Expectations, deliverables and project
                    deadlines are determined
                  </option>
                  <option value="organization">
                    Growth/Scale: A scaling strategy is developed
                  </option>
                  <option value="organization">
                    Influence: Advocacy efforts are undertaken with national and
                    international stakeholders
                  </option>
                  <option value="organization">Other</option>
                </Form.Select>
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Other</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>
                  Please briefly describe the objective of your collaboration.
                  (ie. what is the system you would like to change or the
                  problem you would like to solve and why) (150 words max)
                </Form.Label>
                <Form.Control as="textarea" rows={3} />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>
                  Are there any organisations/individuals within the community
                  that you are specifically interested in collaborating with?
                </Form.Label>
                <Form.Control as="textarea" rows={3} />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>
                  Which region will your collaboration serve?
                </Form.Label>
                <Form.Control as="textarea" rows={3} />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>
                  Please tell us which SDG(s) the collaboration will be
                  addressing. (Please list your top 3.)
                </Form.Label>
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 1: No poverty"}
                />
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 2: Zero Hunger"}
                />
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 3: Good Health and Well-being"}
                />
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 4: Quality Education"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 5: Gender Equality"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 6: Clean Water and Sanitation"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 7: Affordable and Clean Energy"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 8: Decent Work and Economic Growth"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 9: Industry, Innovation and Infrastructure"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 10: Reduced Inequalities"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 11: Sustainable Cities and Communities"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 12: Responsible Consumption and Production"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 13: Climate Action"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 14: Life Below Water"}
                />{" "}
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 15: Life on Land"}
                />
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 16: Peace, Justice and Strong Institutions"}
                />
                <Form.Check
                  type={"checkbox"}
                  id={"default"}
                  label={"SDG 17: Partnerships for the Goals"}
                />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>
                  {" "}
                  Please tell us the main issue(s) this collaboration is
                  addressing.?
                </Form.Label>
                <Form.Control type="text" />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>
                  {" "}
                  Please indicate your collaboration needs.?
                </Form.Label>
                <Form.Control type="text" />
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>
                  {" "}
                  What do you need to get your collaboration started?
                </Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button className="battoun" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal  */}
    </>
  );
};

export default Collaboration;
